import { useEffect } from 'react';
import { Toast as IToast, toast as libToast, useToaster } from 'react-hot-toast';
import styles from './Toast.module.css';
import { ToastOptions } from './Toast.types';
import ToastElement from './ToastElement';

/**
 * Function used to open a toast. Requires the Toast component to be present in one place in the application
 * @param options custom options for showing a toast (label, buttonlabel, onButtonClick, toastType, triggerFocus)
 */
export const showToast = (options: ToastOptions) => {
  const { buttonLabel, onButtonClick } = options;
  const hasCta = buttonLabel !== undefined && onButtonClick !== undefined;
  // t refers to the props coming from `react-hot-toast`
  libToast.custom((t: IToast) => <ToastElement {...options} {...t} />, {
    duration: hasCta ? Infinity : 6000,
    id: options.id,
  });
};

/**
 * Toast container used to render toasts - placed in one place within the application. Toasts are shown using the toast function above.
 */
const Toast: React.FC = () => {
  const { toasts, handlers } = useToaster();

  useEffect(() => {
    // remove existing pauses when no toasts are in the queue
    if (toasts.length === 0) handlers.endPause();
  }, [toasts, handlers]);

  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast) => {
        const ToastComponent = toast.message as React.FC;
        return <ToastComponent key={toast.id} {...toast} {...handlers} />;
      })}
    </div>
  );
};

export default Toast;
